module.exports = __webpack_public_path__ + "static/media/4fullbodyIMG_3509.c9593345.jpg";